import script from "./SharedTaskAssignees.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedTaskAssignees.vue?vue&type=script&setup=true&lang=js"

import "./SharedTaskAssignees.vue?vue&type=style&index=0&id=1c13de34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c13de34"]])

export default __exports__